"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircleSpace = void 0;
var react_1 = __importDefault(require("react"));
var constants_1 = require("../constants");
var colors_1 = require("../../colors");
var CircleSpace = function (_a) {
    var color = _a.color, height = _a.height, size = _a.size, width = _a.width;
    return (react_1.default.createElement("svg", { width: width || size || constants_1.DEFAULT_ICON_SIZE, height: height || size || constants_1.DEFAULT_ICON_SIZE, viewBox: '0 0 32 32', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react_1.default.createElement("path", { d: 'M2 15.9682C2 14.8087 2.50317 13.7062 3.37913 12.9465L13.3791 4.27316C14.883 2.96884 17.117 2.96884 18.6209 4.27316L28.6209 12.9465C29.4968 13.7062 30 14.8087 30 15.9682V26.5728C30 28.782 28.2091 30.5728 26 30.5728H6C3.79086 30.5728 2 28.782 2 26.5728V15.9682Z', fill: color ? (0, colors_1.getColor)(color) : 'currentColor' })));
};
exports.CircleSpace = CircleSpace;
